import React,{createContext,useState,useEffect,useContext} from "react";
import $ from "jquery";

const dataContext = createContext(null);

const {Provider} = dataContext

export const useResume = ()=> {
    const dataCtx = useContext(dataContext);
    if(!dataCtx) throw new Error("please Wrap application in Data Provider for resume");
    return dataCtx;
}

export const DataProvider = ({children})=> {
    const [resume,setResume] = useState({});
    
    // getResumeData() {
    
    const getResume = ()=> {
        $.ajax({
            url: "./resumeData.json",
            dataType: "json",
            cache: false,
            success: function(data) {
                setResume(data)
            },
            error: function(xhr, status, err) {
                console.log(err);
            }
         });
    }

    useEffect(()=>{
       getResume();
    },[])

    return <Provider value={resume}>
        {children}
    </Provider>
}

